import { MAIN_GREEN } from "baseStyles";
import menu from "constants/menu.json";
import { useNavigatePage } from "hooks/useNavigatePage";
import { useSelector } from "react-redux";
import { useLocation } from "react-router";
import { selectLanguage } from "redux/reducers/languageReducer";
import { Container, Copyright, FooterHead, FooterLine, FooterMain, Menu, Wrapper } from "./style";
const Footer = () => {
  const nav = useNavigatePage();
  const location = useLocation();
  const language = useSelector(selectLanguage);

  return (
    <Wrapper>
      <>
        <FooterLine />
        <Container>
          <FooterHead>
            <img loading="lazy" src="/assets/img/Footer_1.svg" alt="" />
            <div>
              <div>Website last Updated : 2023.01.03</div>
              <div>
                <div>SKT Research PTE. LTD.</div>
                <div>20 CECIL STREET #05-03 PLUS SINGAPORE (049705)</div>
              </div>
              <div>Help : help@sketchcoin.io</div>
            </div>
          </FooterHead>
          <FooterMain>
            {menu.data.map((top) => (
              <Menu key={top.title}>
                <div>{language === "ko" ? top.titleKR : top.title}</div>
                <div>
                  {top.sideMenus.map(
                    (side) =>
                      side.status === 1 && (
                        <span
                          key={side.url}
                          style={{
                            color: side.url.split("/")[1] === location.pathname.split("/")[1] ? MAIN_GREEN : "",
                          }}
                          onClick={() => {
                            nav(side.url);
                          }}
                        >
                          {language === "ko" ? side.titleKR : side.title}
                        </span>
                      ),
                  )}
                </div>
              </Menu>
            ))}
          </FooterMain>
        </Container>
        <FooterLine />

        <Copyright>Copyright Ⓒ 2023 Sketch Foundation. All rights</Copyright>
      </>
    </Wrapper>
  );
};

export default Footer;
